import React from 'react'
import classnames from 'classnames'

const ranges = [
  '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
  '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
  '\ud83d[\ude80-\udeff]' // U+1F680 to U+1F6FF
]
const isEmoji = str => str.match(ranges.join('|'))

const Monogram = ({ firstName, lastName, email }) =>
  firstName && isEmoji(firstName.substring(0, 2))
    ? firstName.substring(0, 2)
    : lastName && isEmoji(lastName.substring(0, 2))
    ? lastName.substring(0, 2)
    : `${firstName != null ? firstName.charAt(0) : ''}${
        lastName != null ? lastName.charAt(0) : ''
      }`.toUpperCase() || email.charAt(0).toUpperCase()

const Name = ({ firstName, lastName, email }) =>
  firstName && lastName
    ? `${firstName != null ? firstName : ''} ${
        lastName != null ? lastName : ''
      }`
    : email

export const YourLabel = ({ classNames }) => (
  <div className="circleContainer">
    <div className="labelOuter">
      <div className={classnames(classNames)}>You</div>
    </div>
    <div
      className={classnames({
        creditsProgressBarLong: true,
        leftRadius: true,
        creditsProgressBarColor: classNames.youLabelColored
      })}
    />
  </div>
)
// shows the user initials and first and last name
const FriendLabel = ({
  firstName = '',
  lastName = '',
  email,
  size = 'small',
  showName = true,
  showEmail = true,
  classNames,
  friendLabelClasses,
  ...rest
}) => (
  <div className={classnames(friendLabelClasses, 'friendsLabel')} {...rest}>
    {size === 'small' ? (
      <div
        className={classnames(classNames)}
        title={firstName && lastName ? `${firstName} ${lastName}` : `${email}`}
      >
        <Monogram
          {...{
            firstName,
            lastName,
            email
          }}
        />
      </div>
    ) : (
      <div
        className="friendIconFull"
        title={firstName && lastName ? `${firstName} ${lastName}` : `${email}`}
      >
        <Monogram
          {...{
            firstName,
            lastName,
            email
          }}
        />
      </div>
    )}
    {(showName || showEmail) && (
      <div className="friendDetails">
        <div>
          {showName && (
            <Name
              {...{
                firstName,
                lastName,
                email
              }}
            />
          )}
          {showEmail && <div className="friendEmail">{email}</div>}
        </div>
      </div>
    )}
  </div>
)

export default FriendLabel
